<script setup lang="ts">
import { MOCK_PROMPTS } from '~~/src/pages/prompt/[id]/@data/prompts'
interface IProps {
  size?: number
}

const props = withDefaults(defineProps<IProps>(), {
  size: 3,
})

const { size } = toRefs(props)
const { colors } = useTheme()
</script>

<template>
  <section relative>
    <div blur-5 select-none whitespace-pre-wrap>
      <PromptList :elementals="MOCK_PROMPTS.slice(0, size)" variant="in-list" />
    </div>
    <div absolute top-0 left-0 right-0 bottom-0 flex center>
      <div p-3 md:p-5 flex flex-col items-center justify-center gap-2 rounded-3 b-1 bg-white b-softGray text-lg>
        <IconHide :size="24" :stroke-color="colors.softBlack" />
        <Text variant="small" text-center :color="colors.softBlack">
          You must buy the List<br>
          in order to unlock it
        </Text>
      </div>
    </div>
  </section>
</template>
